import { $, addAction, INIT } from '@situation/setdesign.util';
import { selectors } from './constants';
import StateManager from './state/StateManager';
import CalendarController from './controllers/CalendarController';
import FormController from './controllers/FormController';

const ticketCalendarReady = (() => {
    if (typeof window === 'undefined') {
        return Promise.resolve(null);
    }

    let hasResolved = false;
    return new Promise((resolve) => {
        const resolveOnce = (TicketCalendar) => {
            if (hasResolved || !TicketCalendar) return;

            hasResolved = true;
            resolve(TicketCalendar);
        };
        if (window.TicketCalendar && window.TicketCalendar.bus) {
            resolveOnce(window.TicketCalendar);
            return;
        }

        $(document).one('TicketCalendar.init', (e, TicketCalendar) => {
            resolveOnce(TicketCalendar);
        });
    });
})();
addAction(INIT, () => {
    if (!document.querySelector(selectors.calendarModal)) {
        return;
    }

    // We no longer need to wait for the form here. The FormController handles it.
    ticketCalendarReady.then((TicketCalendar) => {
        if (!TicketCalendar) return;

        const stateManager = new StateManager();
        const calendarController = new CalendarController(stateManager, TicketCalendar);
        const formController = new FormController(stateManager);
        calendarController.init();
        formController.init();
    });
});
